import { round } from "mathjs";
export function toRound(value, decimals = 2) {
  return round(value, decimals);
}
